import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '@env/environment';
import { Logger } from '@core/services';

const log = new Logger('ErrorHandlerInterceptor');

/**
 * Adds a default error handler to all requests.
 */
@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerInterceptor implements HttpInterceptor {
  // private readonly _toast: HotToastService = inject(HotToastService);
  // private readonly _translateService = inject(TranslateService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError((error) => this._errorHandler(error)));
  }

  // Customize the default error handler here if needed
  private _errorHandler(response: HttpEvent<any>): Observable<HttpEvent<any>> {
    // check if status is 401 or 403 and redirect to login page
    if ((response as any).status === 401 || (response as any).status === 403) {
      window.location.href = '/logout';
    }

    if (!environment.production) {
      // Do something with the error
      log.error('Request error', response);
    }
    // Each individual error handled with toast in there respective files.
    // this._toast.error(this._translateService.instant('Something went wrong'), {
    //   id: 'error-handler',
    //   role: 'alert',
    // });

    throw response;
  }
}
